// Dev auth bypass: lets `npm run dev` and Playwright run without Entra.
// Guard: a production build must never ship with the flag on. `.env.production` never defines
// it, so this throw is a belt-and-braces check against a leaked env var.

export const DEV_AUTH_BYPASS = import.meta.env.VITE_DEV_AUTH_BYPASS === 'true';

if (DEV_AUTH_BYPASS && import.meta.env.PROD) {
  throw new Error(
    'VITE_DEV_AUTH_BYPASS is enabled in a production build. Refusing to start.',
  );
}

export const DEV_USER = {
  id: '00000000-0000-0000-0000-000000000001',
  name: 'Dev User',
  email: 'dev@aiqbee.com',
} as const;
